import { z } from 'zod';
import type { FieldPath } from '@getmoments/env42';

// Kept free of browser and React imports: vite.config.ts validates the production build against it.
const path = z.string().startsWith('/');

export const AppConfigSchema = z.object({
  auth0Domain: z.string().min(1),
  auth0ClientId: z.string().min(1),
  auth0Audience: z.string().min(1),
  /** Appended to window.location.origin, so it must be a path. */
  loginRedirectUrl: path,
  logoutRedirectUrl: path,
  adminBackendUri: z.string().url(),
  temporalWebUiUrl: z.string().default(''),
  /** Opened with the therapist id appended. */
  azureDiagnosticsBlobPrefix: z.string().url(),
});

export type AppConfig = z.infer<typeof AppConfigSchema>;

export const AppConfigEnVarsSchema = z.enum([
  'NEXT_PUBLIC_AUTH0_DOMAIN',
  'NEXT_PUBLIC_AUTH0_CLIENT_ID',
  'NEXT_PUBLIC_AUTH0_AUDIENCE',
  'NEXT_PUBLIC_LOGIN_REDIRECT_URL',
  'NEXT_PUBLIC_LOGOUT_REDIRECT_URL',
  'NEXT_PUBLIC_ADMIN_BACKEND_URI',
  'NEXT_PUBLIC_TEMPORAL_WEB_UI_URL',
  'NEXT_AZURE_DIAGNOSTICS_BLOB_PREFIX',
]);

export type AppConfigEnvVarNames = z.infer<
  typeof AppConfigEnVarsSchema
>;

export const appConfigEnvVarsMap: Record<
  FieldPath<AppConfig>,
  AppConfigEnvVarNames
> = {
  auth0Domain: 'NEXT_PUBLIC_AUTH0_DOMAIN',
  auth0ClientId: 'NEXT_PUBLIC_AUTH0_CLIENT_ID',
  auth0Audience: 'NEXT_PUBLIC_AUTH0_AUDIENCE',
  loginRedirectUrl: 'NEXT_PUBLIC_LOGIN_REDIRECT_URL',
  logoutRedirectUrl: 'NEXT_PUBLIC_LOGOUT_REDIRECT_URL',
  adminBackendUri: 'NEXT_PUBLIC_ADMIN_BACKEND_URI',
  temporalWebUiUrl: 'NEXT_PUBLIC_TEMPORAL_WEB_UI_URL',
  azureDiagnosticsBlobPrefix: 'NEXT_AZURE_DIAGNOSTICS_BLOB_PREFIX',
};
